import { Component, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'tog-table-cell',
  templateUrl: './table-cell.component.html',
  styleUrls: ['./table-cell.component.scss']
})
export class TableCellComponent implements OnInit {
  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/table/table-cell/table-cell.component.ts